const FaqAccordeon = {
    init() {
        const wrappers = document.querySelectorAll('.js-accordeon');
        
        if (wrappers) {
            wrappers.forEach(wrapper => {
                let firstAccordeonOpen = false;
                if (wrapper.classList.contains('js-accordeon-first-open')) {
                    firstAccordeonOpen = true;
                }
                const acc = wrapper.querySelectorAll('.js-accordeon-title');
                let i;

                for (i = 0; i < acc.length; i++) {
                    // initialize de la premier question faq
                    if (i === 0 && firstAccordeonOpen) {
                        acc[0].nextElementSibling.style.maxHeight = acc[0].nextElementSibling.scrollHeight + 'px';
                    }

                    // Clique sur une question
                    acc[i].onclick = function() {
                        // variables
                        const panel = this.nextElementSibling;
                        const listContenuFaq = wrapper.querySelectorAll('.js-accordeon-content');
                        const listFaqActive = wrapper.querySelectorAll('.active');

                        /* Si le content est deja affiché - minimize*/
                        if (panel.style.maxHeight) {
                            // reduit le content deja affiché
                            panel.style.maxHeight = null;
                            // supprime la class 'active'
                            this.classList.remove('active');
                        } else {
                            // pannel isnt open...
                            // goes through the buttons and removes the 'active' css (+ and -)
                            for (let ii = 0; ii < listFaqActive.length; ii++) {
                                listFaqActive[ii].classList.remove('active');
                            }
                            //Goes through and removes 'activ' from the css, also minifies any 'panels' that might be open
                            for (let iii = 0; iii < listContenuFaq.length; iii++) {
                                this.classList.remove('active');
                                listContenuFaq[iii].style.maxHeight = null;
                            }

                            //opens the specified pannel
                            panel.style.maxHeight = panel.scrollHeight + 'px';
                            //adds the 'active' addition to the css.
                            this.classList.add('active');
                        }
                    };
                }
            });
        }
    },
};

export default FaqAccordeon;
